<template>
  <div>
    <el-dialog custom-class="customDialog" :title="$t('İştirakçı')" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="showModal"
      :width="labelWidth === '210px' ? '80%' : '100%'" top="5vh" append-to-body @open="opened()">
      <el-form :disabled="readonly" ref="policy" :model="item"  :label-position="labelPosition" :label-width="labelWidth" size="small" :rules="rules"
        v-loading="loading">
        <el-tabs v-model="activeName" plane>
          <div class="d-flex justify-content-center" v-if="mode == 'New'" style="padding-bottom: 20px">
            <el-switch @change="participantChanged" v-model="insured" :active-text="$t('Sığortalı')"
              :inactive-text="$t('Üçüncü_tərəf')">
            </el-switch>

          </div>
            <hr v-if="(!insured) || (insured && mode === 'New')" width="30%" size="50"
            style="margin-top: -10px;margin-bottom: 5px; position: relative; height: 1px; background: rgb(211, 211, 211);"
            align="center">
          <div v-if="(!insured) || (insured && mode === 'New') || (mode === 'Edit')" class="d-flex justify-content-center"
            >
            <el-form-item :label="$t('SŞ_nömrəsi')" v-if="(insured) " prop="policyNumber">
              <el-input v-mask="'XXXXXXXXXXXX'" v-model="item.policyNumber" style="width: 100%;">
                <span v-if="!insured" slot="append">&nbsp;</span>
                <el-button  class="primary" slot="append"
                  :readonly="mode === 'Edit' && insured && this.item.insuranceType !== null" size="small"
                  icon="el-icon-search" @click="onsearch(item.policyNumber)"> </el-button>
              </el-input>
            </el-form-item>
          </div>

          <div class="row" v-if="!item.noInfo">
            <div class="col-md-6 col-12 ">
              <el-form-item label="" v-if="!insured" prop="personType">

                <el-radio-group class="custom-readonly"
                  :disabled="(insured) || (!insured && this.item.participantType === 3)" v-model="item.personType">
                  <div
                    :class="{ 'flex-direction-column': labelWidth == '152px', 'flex-direction-row': labelWidth != '152px' }">

                    <el-radio :label="1">{{$t('Fiziki')}}</el-radio>
                    <el-radio :label="2">{{$t('Hüquqi')}}</el-radio>
                    <el-radio :label="3">{{$t('Fərdi_sahibkar')}}</el-radio>
                  </div>

                </el-radio-group>
              </el-form-item>

              <el-form-item v-if="(insured) || (!insured && this.item.participantType === 3)" :label="$t('Sığorta_müddəti')"
                prop="insurancePeriod">
                <el-input v-if="(insured && standalone) || (!insured && this.item.participantType === 3)"
                  v-model="item.insurancePeriod" readonly></el-input>

              </el-form-item>
              <el-form-item v-if="(insured || item.participantType === 3)" :label="item.personType === 1 ? $t('FİN') : $t('VÖEN')"
                prop="identNumber">
                <el-input id="search" readonly v-model="item.identNumber" style="width: 100%;">

                </el-input>
              </el-form-item>
              <el-form-item v-if="(!insured && item.participantType !== 3)"
                :label="item.personType === 1 ? $t('FİN') : $t('VÖEN')" prop="identNumber">
                <el-checkbox @change="onIsInsuredIdent" v-if="insured" v-model="isInsuredIdent">{{$t('Sığortalı_ilə_eynidir')}}</el-checkbox>
                <el-input id="search" v-model="item.otherIdentNumber" style="width: 100%;">
                  <span v-if="mode == 'New'" slot="append">&nbsp;</span>
                  <el-button class="primary" size="small" slot="append" icon="el-icon-search"
                    @click="item.personType === 1 ? onSearchAsan('PersonalInfo') : onSearchAsan('VoenInfo')">
                  </el-button>
                </el-input>
              </el-form-item>
                 <el-form-item v-if="!insured" :label="$t('A.S.A')" prop="partPersonName">
                  <el-checkbox @change="onIsInsured" v-if="item.participantType === 3 || insured" v-model="isInsured">
                    {{$t('Sığortalı_ilə_eynidir')}}
                  </el-checkbox>

                  <el-input v-upper v-letter :placeholder="$t('A.S.A.')" v-model="item.partPersonName" size="small">
                  </el-input>
                </el-form-item>

                <el-form-item  v-if="!insured" :label="$t('Telefon_nömrəsi')"  prop="partPersonPhone">
                  <el-checkbox @change="onIsInsuredPhone" v-if="this.item.participantType === 3 || insured"
                    v-model="isInsuredPhone">{{$t('Sığortalı_ilə_eynidir')}}</el-checkbox>
                  <phone v-model="item.partPersonPhone" />
                </el-form-item>
                <el-form-item   v-if="!insured" :label="$t('Əlavə_nömrə')" prop="otherDriverPhone">
                  <phone ref="phone" v-model="item.otherDriverPhone" />
                </el-form-item>

              <el-form-item :label="$t('Təqribi_zərər')" v-if="item.damageType !== 1 && item.damageType !== 2 && !insured"
                prop="damageSum">
                <el-input type="number" v-model="item.damageSum"></el-input>
              </el-form-item>

           
              <el-form-item v-if="((insured) || (!insured && this.item.participantType === 3)) ||
                (item.personType !== 1)" prop="personName" :label="item.personType === 2 ? $t('Şirkətin_adı') : $t('A.S.A.')">
                <el-input v-model="item.personName" :readonly="insured || item.participantType === 3"></el-input>
              </el-form-item>
              <el-form-item :label="$t('Əlaqə_nömrəsi')" v-if="(insured) || (!insured && this.item.participantType === 3)"
                prop="phone">
                <phone :readonly="insured || item.participantType === 3" v-model="item.phone" />
              </el-form-item>
          


            </div>
            <div class="col-md-6 col-12">
             
                <el-form-item :label="$t('Əmlak_adı')" v-if="insured" prop="otherPropertyName">
                  <el-input v-model="item.otherPropertyName"></el-input>
                </el-form-item>

              <el-form-item :label="$t('Təqribi_zərər')" v-if="item.damageType === 1 || insured" prop="damageSum">
                <el-input type="number" v-model="item.damageSum"></el-input>
              </el-form-item>

                <div 
                  style="display: grid; grid-template-columns: repeat(auto-fill, minmax(550px, 1fr)); gap: 5px;">
                  <div>
                    <el-form-item :label="$t('Subroqasiya_ehtimalı')" prop="subragation">
                      <el-radio-group style="display: flex; justify-content: start; align-items: center;"
                        v-model="item.subragation">
                        <el-radio :label="1">{{$t('Var')}}</el-radio>
                        <el-radio :label="0">{{$t('Yoxdur')}}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('Dələduzluqda_şübhə')" prop="fraud">
                      <el-radio-group style="display: flex; justify-content: start; align-items: center;"
                        v-model="item.fraud">
                        <el-radio :label="1">{{$t('Var')}}</el-radio>
                        <el-radio :label="0">{{$t('Yoxdur')}}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>

              </div>

            </div>
            <div class="col-md-12 col-12">
              <el-form-item :label="$t('Qeyd')" prop="descr">
                <el-input rows="5" type="textarea" resize="none" v-model="item.descr"></el-input>
              </el-form-item>
            </div>
          </div>

        </el-tabs>
      </el-form>

      <span slot="footer" class="dialog-footer">
      
        <el-button size="small" v-if="!readonly" type="primary" @click="clickSave">{{$t('Yadda_saxla')}}</el-button>
        <el-button size="small"  @click="showModal = false">{{$t('İmtina')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ParticipantType } from "../../services/types";
import {
  CreateParticipant,
  UpdateParticipant,
  GetParticipant,
} from "../../services/accident";
import Phone from "./Phone.vue";
import ServiceCenters from "../components/ServiceCenters.vue";
import OfficialAgency from "../components/OfficialAgency.vue";
import { DateTimeToJson, DateToString, DateTimeToString, DateTimeReverseToString, standalone,labelPosition } from "../../services/helper";
import { salesapi, asanapi, newsalesapi } from "../../services/sales";

import { mask } from "vue-the-mask";

export default {
  directives: {
    mask,
  },
  components: {
    Phone,
  },
  computed: {
    rules() {
      let rules = {
        serviceCenterId: [
          {
            required: !this.item.notSendService,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
        // brandId: [
        //   {
        //     required: this.item.brandId || !this.item.modelId,
        //     message: this.$t('Sütun_mütləqdir'),
        //     trigger: ["blur", "change"],
        //   },
        // ],
        policyNumber: [
          {
            required: (!this.item.policyNumber && this.mode === "New"),
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],

        insurancePeriod: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
        personName: [
          {
            required: !this.item.personName && this.mode === "New",
            message: this.$t('Sütun_mütləqdir'),
            trigger: "change",
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
        vin: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
        vinCheck: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
        partPersonName: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
        partPersonPhone: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
        driverLicense: [
          {
            required: this.insured || this.item.participantType === 3,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
        damageSum: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],

        productionYear: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
        officialAgencyId: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
        insuranceCompId: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
        subragation: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
        fraud: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],
        orgName: [
          {
            required: true,
            message: this.$t('Sütun_mütləqdir'),
            trigger: ["blur", "change"],
          },
        ],

      };

      return rules;
    },
  },
  data() {
    return {
      activeName: "person",
      showModal: false,
      search: "",
      searchType: 1,
      asanType: null,
      mode: "",
      loading: false,
      item: {},
      insured: true,
      standalone: standalone,
      insPeriod: [],
      policies: [],
      policy: [],
      policyIndex: null,
      policyCount: 0,
      uid: this.$store.state.user.id,
      isInsured: null,
      isInsuredPhone: null,
      isInsuredIdent: null,
      labelWidth: '210px',
      readonly: false,
      labelPosition: labelPosition,
      asanData: {
        Personal: {},
        Voen: {},
        Vehicle: {},
      },
      roles: this.$store.state.user.roles,

    };
  },
  methods: {
    new(id) {
      this.activeName = "person";
      this.item = new ParticipantType();
      this.item.personType = 1;
      this.mode = "New";
      this.showModal = true;
      this.item.accidentId = id;
      this.search = null;
      this.insured = false;
      this.readonly = false;
          this.$nextTick(() => {
              if (this.$refs.policy) {
                this.$refs.policy.clearValidate();
              }
            });
    },
    edit(id, readonly) {
      this.readonly = readonly;
      this.loading = true;
      this.activeName = "person";
      this.mode = "Edit";
      this.showModal = true;
      this.search = null;
      this.policyCount = null;

      GetParticipant(id).then((response) => {
        this.loading = false;
        this.isInsured = null;
        this.isInsuredPhone = null;
        if (response.data.data) {
          this.item = response.data.data;
          this.insured = this.item.participantType === 1;
          this.policyIndex = this.item.policyNumber;
              this.$nextTick(() => {
              if (this.$refs.policy) {
                this.$refs.policy.clearValidate();
              }
            });
        } else {
          this.showModal = false;
          this.$message({
            type: "warning",
            message: "Səhv əməliyyat",
          });
        }
      });
    },



    formatPhoneNumber(phoneNumber) {
      if (!phoneNumber) return null;

      const cleaned = ('' + phoneNumber).replace(/\D/g, '');
      const match = cleaned.match(/^(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})$/);

      if (match) {
        return '+' + match[1] + ' (' + match[2] + ') ' + match[3] + '-' + match[4] + '-' + match[5];
      }

      return null;
    },
    onSearchAsan(asanType) {
      this.loading = true;
      const number = asanType == 'VehicleInfo' ? this.item.policyNumber : this.item.otherIdentNumber;

      asanapi(asanType, number, this.uid).then((response) => {
        if (!response.data.data.response) {
          this.item.participantType = 2;
          this.$message({
            type: "error",
            message: "Məlumatların tam və düzgün olmasını yoxlayın",
          });
        } else {
          switch (asanType) {
            case 'PersonalInfo':
              this.asanData.Personal = response.data.data.response;
              this.item.personName = `${this.asanData.Personal.surname} ${this.asanData.Personal.name} ${this.asanData.Personal.patronymic}`;
              if (!this.insured) {
                this.item.partPersonName = this.item.personName;
              }
              break;
            case 'VehicleInfo':
              this.asanData.Vehicle = response.data.data.response.car;
              Object.assign(this.item, {
                customBrandModel: this.asanData.Vehicle.mark,
                productionYear: this.asanData.Vehicle.manufactoringYear,
                vin: this.asanData.Vehicle.bodyNumber,
                participantType: 2,
              });
              break;
            case 'VoenInfo':
              this.asanData.Voen = response.data.data.response;
              this.item.personName = this.asanData.Voen.legalEntity.fullName;
              break;
          }
        }
        this.loading = false;
      }).catch((error) => {
        this.$message({
          type: "error",
          message: "Zəhmət olmasa yenidən cəhd edin",
        });
        this.loading = false;
      });
    },

    onIsInsured() {
      if (this.isInsured)
        this.item.partPersonName = this.item.personName;
      else
        this.item.partPersonName = "";
    },
    onIsInsuredPhone() {
      if (this.isInsuredPhone) {
        this.item.partPersonPhone = this.item.phone;
      }
      else {
        this.item.partPersonPhone = "";
      }
    },
    onIsInsuredIdent() {
      if (this.isInsuredIdent) {
        this.item.otherIdentNumber = this.item.identNumber;
      }
      else {
        this.item.otherIdentNumber = "";
      }
    },
    updatePolicyAttributes(policy) {
      const NA = "N/A";
      this.item.policyNumber = policy.policy_number || NA;
      this.item.insuredName = this.item.personName = policy.insured_name || NA;
      this.item.customBrandModel = policy.brand_name && policy.model_name ? `${policy.brand_name} ${policy.model_name}` : NA;
      this.item.identNumber = policy.ident_number || NA;
      this.item.phone = policy.phone ? this.formatPhoneNumber(policy.phone) : null;
      this.item.productionYear = policy.production_year || NA;
      this.item.vin = policy.vin || NA;
      this.item.insuranceType = policy.policy_type === 'İcbari' ? 1 : policy.policy_type === 'Kasko' ? 2 : undefined;
      this.item.policyId = policy.policy_number;
      this.item.personType = policy.person_type;
      this.item.startDate = policy.start_date;
      this.item.endDate = policy.end_date;
      this.item.insurancePeriod = `${DateTimeReverseToString(this.item.startDate)} - ${DateTimeReverseToString(this.item.endDate)}`;
      this.item.insuranceCompId = 1;
    }
    ,
    onsearch() {
      this.loading = true;

      const salesApiPromise = salesapi(this.item.policyNumber).then((response) => {
        return response.data.data || [];
      });

      const newsalesApiPromise = newsalesapi(this.item.policyNumber).then((response) => {
        return response.data.data || [];
      });

      Promise.all([salesApiPromise, newsalesApiPromise])
        .then(([salesApiData, newsalesApiData]) => {
          this.policies = [...salesApiData, ...newsalesApiData].map(policy => ({
            ...policy,
            start_date: DateTimeToString(policy.start_date),
            end_date: DateTimeToString(policy.end_date),
          }));

                  this.policies = [
            {
              "policy_number": "ims1200",
              "policy_type": "Kasko",
              "policy_status": "Buraxılmış",
              "person_type": 1,
              "person_type_name": "Fiziki şəxs",
              "start_date": "2023-03-13T20:52:42",
              "end_date": "2025-03-13T20:52:42",
              "ident_number": "5TPBYCA",
              "insured_name": "Məmmədəliyev Orxan",
              "insured_address": null,
              "reg_number": "90TV889",
              "phone": "994558228424",
              "beneficiary_name": null,
              "production_year": 2014,
              "kasko_premium_cost": null,
              "kasko_premium": null,
              "is_partial": null,
              "franchise_per_one": null,
              "bi_property": null,
              "bi_premium_cost": null,
              "accident_premium": null,
              "accident_premium_cost": null,
              "total_accident_premium": null,
              "total_accident_premium_cost": null,
              "total_civil_premium": null,
              "total_civil_premium_cost": null,
              "premium": 60.09,
              "branch_name": "Şirkət"
            },
          
          ]

          this.policyCount = this.policies.length;
          this.policyIndex = !this.policyIndex || this.policyCount === 1 ? 0 : this.policyIndex;
          this.policy = this.policies[this.policyIndex];

          if (this.policyCount > 0) {
            this.updatePolicyAttributes(this.policy);
            this.item.participantType = this.insured ? this.item.participantType : 3;
          } else {
            this.$message({
              type: "error",
              message: "Sığorta şəhadətnaməsi tapılmadı",
            });
          }

          this.loading = false;
        })
        .catch((error) => {
          if (typeof this.policy !== 'undefined') {
            this.$message({
              type: "error",
              message: "Zəhmət olmasa yenidən cəhd edin",
            });
          }
          this.loading = false;
        });
    }


    ,
    participantChanged() {
      if (this.standalone) {
        this.resetForm().then(() => {
          if (this.insured) {
            this.item.participantType = 1;
          }
          else {
            this.item.participantType = 2;
          }
          this.item.personType = 1;
          this.item.damageType = 1;
          this.item.policyNumber = null;
          this.isInsured = null;
          this.policyIndex = null;
          this.isInsuredIdent = null;
          this.isInsuredPhone = null;
          this.item.otherIdentNumber = null;
          this.item.drivingYears = null;
          this.item.insuranceType = null;

        });
      }
    },
    changeDamageType() {

      if (this.insured) {
        this.item.participantType = 1;
      }
      else {
        this.item.participantType = 2;
      }
      this.item.partPersonName = "";
      this.item.policyNumber = "";
      this.item.identNumber = ""
      this.item.partPersonPhone = "";
      this.item.vin = "";
      this.item.phone = "";
      this.item.productionYear = null;
      this.item.damageSum = null;
      this.item.customBrandModel = null;
      this.item.purposeOfUse = null;
      this.item.otherPurposeOfUse = null;
      this.item.driverLicense = null;
      this.item.officialAgencyId = null;
      this.item.otherAgency = null;
      this.item.serviceCenterId = null;
      this.item.notSendService = null;
      this.item.subragation = null;
      this.item.fraud = null;
      this.item.vinCheck = null;
      this.item.orgName = "";
      this.item.insuranceCompId = null;
      this.item.otherDriverPhone = "";
      this.item.insurancePeriod = "";
      this.item.personName = ""
      this.isInsured = null;
      this.isInsuredIdent = null;
      this.isInsuredPhone = null;
      this.item.otherIdentNumber = null;
      this.policyIndex = null;
      this.item.drivingYears = null;
      this.item.insuranceType = null;
    },
    opened() {
      this.resetForm();
    },
    resetForm() {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          this.$refs["policy"].resetFields();
          this.item.personType = 1;
          this.item.partPersonName = "";
          this.item.partPersonPhone = "";
          this.item.vin = "";
          this.item.phone = "";
          this.item.productionYear = null;
          this.item.damageSum = null;
          this.item.customBrandModel = null;
          this.item.purposeOfUse = null;
          this.item.otherPurposeOfUse = null;
          this.item.driverLicense = null;
          this.item.officialAgencyId = null;
          this.item.otherAgency = null;
          this.item.serviceCenterId = null;
          this.item.notSendService = null;
          this.item.subragation = null;
          this.item.fraud = null;
          this.item.vinCheck = null;
          this.item.orgName = "";
          this.item.insuranceCompId = null;
          this.item.otherDriverPhone = "";
          this.item.insurancePeriod = "";
          this.item.personName = ""
          this.isInsured = null;
          this.isInsuredIdent = null;
          this.isInsuredPhone = null;
          this.item.otherIdentNumber = null;
          this.item.policyNumber = null;
          this.policyIndex = null;
          this.item.drivingYears = null;
          this.item.insuranceType = null;
          if (this.mode === "New") {
            this.policyIndex = null;
            this.policies = []
          }
        })
        resolve(this.$refs["policy"]);
      })
    },
    updateField(field, value) {
      this.item[field] = value;
      this.$refs['policy'].validateField(field);
    },
    participantTypeData() {
      if (this.insured === 2) {
        this.item.policyId = null;
        this.item.startDate = null;
        this.item.endDate = null;
        this.item.policyNumber = null;
        this.item.policyStatus = null;
      }
    },
    clickSave() {
      // if (this.uid === this.item.createUser || this.mode === "New") {
      this.$refs["policy"].validate((valid) => {
        if (!valid) {
          this.$message({
            type: "warning",
            message: "Məlumatların tam və düzgün olmasını yoxlayın",
          });
          return false;
        } else {
            this.saveParticipant();

        }
      });
      // } else {
      //   this.$message({
      //     type: "warning",
      //     message: "Məlumatları dəyişdirmək səlahiyyətiniz yoxdur",
      //   });
      // }
    },
    onNotSendService() {
      this.item.serviceCenterId = null;
      this.item.evacuationStatus = null;
    },
    onNoInfoCompany() {
      this.item.insuranceCompId = null;
    },
    saveParticipant() {
      this.loading = true;
      this.participantTypeData();
      let acc = Object.assign({}, this.item);
      acc.commandUserId = this.uid;
      acc.startDate = DateTimeToJson(this.item.startDate);
      acc.endDate = DateTimeToJson(this.item.endDate);
      if (this.mode === "New") {
        CreateParticipant(acc).then((response) => {
          this.loading = false;
          if (response.data.data) {
            if (!!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0],
              });
            } else {
              this.$emit("saved", { action: "new", id: response.data.data.id });
              this.showModal = false;
              this.$message({
                type: "success",
                message: "Uğurlu əməliyyat",
              });
            }
          } else {
            this.$message({
              type: "error",
              message: "Səhv əməliyyat",
            });
          }
        });
      } else {
        UpdateParticipant(acc).then((response) => {
          this.loading = false;
          if (response.data.data) {
            if (!!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0]
                  ? response.data.errors[0]
                  : "Səhv əməliyyat",
              });
            } else {
              this.$emit("saved", { action: "edit", id: response.data.data.id });
              this.showModal = false;
              this.$message({
                type: "success",
                message: "Uğurlu əməliyyat",
              });
            }
          } else {
            this.$message({
              type: "error",
              message: "Səhv əməliyyat",
            });
          }
        });
      }
    },
    updateLabelWidth() {
      if (window.innerWidth <= 1024) {
        this.labelWidth = '152px';
      } else {
        this.labelWidth = '210px';
      }
    }
  },
  mounted() {
  },
  created() {
    this.updateLabelWidth();
    window.addEventListener('resize', this.updateLabelWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateLabelWidth);
  }
};
</script>


<style lang="scss" >
.custom-label {
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}

.el-input-group__append,
.el-input-group__prepend {
  background-color: white;
  border: 0;
}

.primary {
  color: #FFF !important;
  background-color: #409EFF !important;
  border-color: #409EFF !important;
}

.placeholder .el-input__inner::placeholder {
  color: var(--font-primary) !important;
}

/* google */
.placeholder .el-input__inner::-webkit-input-placeholder {
  color: var(--font-primary) !important;
}

/* firefox */
.placeholder .el-input__inner:-moz-placeholder {
  color: var(--font-primary) !important;
}

/*ie*/
.placeholder .el-input__inner:-ms-input-placeholder {
 color: var(--font-primary) !important;
}

@media (max-width: 768px) and (max-height: 1024px) {
  .responsive-form-item {
    /* Your responsive styles here. For instance, */
    display: block;
  }
}

.flex-direction-column {
  display: flex;
  flex-direction: column;
}

.flex-direction-row {
  display: flex;
  flex-direction: row;
}

.custom-readonly .el-radio.is-disabled .el-radio__input.is-disabled .el-radio__inner {
  background-color: #fff;
  border-color: #d9d9d9;
}

.custom-readonly .el-radio.is-disabled .el-radio__label {
  color: #000;
}

.custom-readonly .el-checkbox.is-disabled .el-checkbox__input.is-disabled .el-checkbox__inner {
  background-color: #f30a0a;
  border-color: #1c0ed7;
}

.custom-readonly .el-checkbox.is-disabled .el-checkbox__label {
  color: #000;
}

.customDialog.el-dialog {
    padding: 0 20px;
   color: var(--font-primary) !important;
   font-size: var(--font-large);
    word-break: break-all;
  }
</style>